import {createReducer} from "typesafe-actions";
import update from "immutability-helper";
import {gotTimestamps} from "../actions/signatures";
import {TimestampState} from "../types/timestamps";

const initialState: TimestampState = {
    total: 0,
};

export const timestampsReducer = createReducer(initialState)
    .handleAction(gotTimestamps, (state, action) => update(state, {
        timestamps: {$set: action.payload.items},
        total: {$set: action.payload.total},
    }))
;
